import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Swap2Icon } from '@blade/ui-kit'

import type { WalletModel } from '@root/entities/wallet'

type Props = {
  wallet: WalletModel
  onTransactionsClick: (wallet: WalletModel) => void
}

export const WalletsTableTransactionsCell: React.FC<Props> = ({
  wallet,
  onTransactionsClick,
}) => {
  const { t } = useTranslation()

  return (
    <Root onClick={() => onTransactionsClick(wallet)}>
      <Icon size={16} />
      <div>{t('transaction_other')}</div>
    </Root>
  )
}

const Root = styled.div`
  color: var(--text-9);

  font-size: 1em;
  font-weight: 500;
  line-height: 16px;

  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 3px;
  cursor: pointer;
  transition: color 0.15s linear;

  &:hover {
    color: var(--text-11);
  }
`

const Icon = styled(Swap2Icon)`
  transform: rotate(90deg);
`
